import { ACTION_SET_LOAN_PARAMS } from "../ActionTypes/LoanModuleActionTypes";

const initialState: any = {
  userTypeId: 0,
  loanParameters: {},
};
export const LoanModuleReducer = (
  state: any = initialState,
  action: any
) => {
  switch (action.type) {
    case ACTION_SET_LOAN_PARAMS:
      return (state = {
        ...state,
        loanParameters: action.loanParameters,
      });

    default:
      return state;
  }
  return state;
};
